import { textFilter } from "react-bootstrap-table2-filter";
import { FieldParams } from "../../core/FieldObject";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
  PostJson,
} from "../../core/Helper";
import { FieldDataType, FormControlType } from "../../core/Helper2";

export const PatientObj = (props) => {
  const { prefixClick, idCardChanged } = props;

  const cancleClick = (item, setObject) => {
    if (!setObject) return;
    setObject((pv) => ({
      ...pv,
      ...DeepMergeObject(
        DotStringToObject(item.fieldName + "." + item.searchValueName, 0),
        DotStringToObject(item.fieldName + "." + item.searchDisplayName, null)
      ),
    }));
  };
  return {
    AppointId: {
      ...new FieldParams(
        "PatientId",
        "",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
      isHiddenColumn: true,
    },
    IdCardNo: {
      ...new FieldParams(
        "IdCardNo",
        "เลขที่บัตร",
        null,
        null,
        FormControlType.FORMATTED_TEXT
      ),
      onChange: idCardChanged,
    },
    Prefix: {
      ...new FieldParams(
        "Prefix",
        "คำนำหน้า",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "Prefix.PrefixId",
      searchDisplayName: "PrefixText",
      searchValueName: "PrefixID",
      searchButtonClick: prefixClick,
      searchCancelClick: cancleClick,
    },
    Firstname: {
      ...new FieldParams("Firstname", "ชื่อ"),
    },
    Lastname: {
      ...new FieldParams("Lastname", "สกุล"),
    },
    Gender: {
      ...new FieldParams(
        "Gender",
        "เพศ",
        true,
        FieldDataType.TEXT,
        FormControlType.SELECT
      ),
      selectData: [
        { GenderId: 1, GenderName: "ชาย" },
        { GenderId: 2, GenderName: "หญิง" },
      ],
      selectHasFirstOption: false,
      selectValueOnly: false,
      selectValueName: "GenderId",
      selectDisplayName: "GenderName",
    },
    PrefixEn: {
      ...new FieldParams(
        "PrefixEn",
        "Prefix",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "PrefixEn.PrefixId",
      searchDisplayName: "PrefixText",
      searchValueName: "PrefixID",
      searchButtonClick: prefixClick,
      searchCancelClick: cancleClick,
    },
    FirstnameEng: {
      ...new FieldParams("FirstnameEng", "Firstname"),
    },
    LastnameEng: {
      ...new FieldParams("LastnameEng", "Surname"),
    },
    BirthDate: new FieldParams(
      "BirthDate",
      "วันเกิด",
      true,
      FieldDataType.DATE,
      FormControlType.DATE_PICKER
    ),
    Addr: {
      ...new FieldParams("Addr", "ที่อยู่"),
    },
    Addr2: {
      ...new FieldParams("Addr2", "-"),
    },
  };
};

export class PatientService {
  static async GetList(data, user) {
    return (
      (await PostJson("/api/patient-info/getlist", { data, user })) ?? null
    );
  }

  static async GetItem(data, user) {
    let result = await PostJson("/api/patient-info/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async SaveItem(data, user) {
    return (await PostJson("/api/patient-info/update", { data, user })) ?? null;
  }

  static async DeleteItem(data, user) {
    return (
      (await PostJson("/api/patient-info/delete", {
        data,
        user,
      })) ?? null
    );
  }
}

export const SearchPatient = (props) => {
  const [setSearchB, data, setData, userInfo, item, isPhysician] = props;

  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "patient_id";
  const displayFieldName = "patient_name";

  setSearchB({
    title: "คนไข้",
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "staff_name",
    sql: {
      fields: [
        "patient_id",
        "patient_idcard",
        "concat(b.prefix, firstname, ' ', lastname) patient_name ",
      ],
      tableName: `ba_patient a  inner join sy_prefix b on a.prefixid = b.prefixid `,
      defaultCriteria: ` a.del_flag ='n' `,
      criteriaFields: ["a.patient_idcard", "a.firstname", "a.lastname"],
      criteriaText: "",
      orderBy: ["firstname, lastname"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "patient_idcard",
        text: "เลขที่บัตร",
        sort: true,
        headerStyle: GetHeaderStyle("150px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "patient_name",
        text: "ชื่อ-สกุล คนไข้",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};
